<template>
    <div class="capaMapaA fullHeight" v-if="mapaA"  @click="mapaA=false">
        <div class="row">
            <div class="col-12 mt-5">
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <img :src="`${publicPath}img/mapaPlanta.png`" class="img-responsive" width="50">
                <h2 class="p-0 m-0">76</h2>
                <p class="text-white p-0 m-0" v-html="$t('mundo.plantas-produccion')"></p>
            </div>
            <div class="col-12 mt-5">
                <img :src="`${publicPath}img/mapaPaises.png`" class="img-responsive" width="50">
                <h2 class="p-0 m-0">+170</h2>
                <p class="text-white p-0 m-0" v-html="$t('mundo.paises')"></p>
            </div>
            <div class="col-12 mt-5">
                <img :src="`${publicPath}img/mapaTrabajadores.png`" class="img-responsive" width="50">
                <h2 class="p-0 m-0">+21.000</h2>
                <p class="text-white p-0 m-0" v-html="$t('mundo.trabajadores')"></p>
            </div>
        </div>
    </div>

    <div class="container fonsMapa pt-3 pb-5 "  v-if="!isMobile()">
        <div class="row">
            <div class="col-12 col-lg-5 ps-5 pb-0 m-5 mb-0 mx-0 text-center text-lg-start">
                <h2 v-html="$t('mundo.rc-mundo')"></h2>
            </div>
            <div class="col-7 pe-5 pb-0 pt-3 m-5 mx-0 text-end d-none d-lg-block" style="vertical-align: bottom">
                <h5> {{$t('mundo.fabricas')}}</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-10 position-relative pe-5 m-0 m-auto">
                <div class="mapaCercleAmerica d-none d-lg-block" data-aos="zoom-in" data-aos-delay="700" data-aos-easing="easy-out" data-aos-duration="1000">
                    <div class="contentCercle">
                        <img :src="`${publicPath}img/mapaCercleAmericaOn_${locale}.png`" class="mapaCercleOn img-responsive">
                        <img :src="`${publicPath}img/mapaCercleAmerica_${locale}.png`" class="mapaCercleOff img-responsive">
                    </div>
                </div>
                <div class="mapaCercleAfrica d-none d-lg-block" data-aos="zoom-in" data-aos-delay="300" data-aos-easing="easy-out" data-aos-duration="1000">
                    <div class="contentCercle">
                        <img :src="`${publicPath}img/mapaCercleAfricaOn_${locale}.png`" class="mapaCercleOn img-responsive">
                        <img :src="`${publicPath}img/mapaCercleAfrica_${locale}.png`" class="mapaCercleOff img-responsive">
                    </div>
                </div>
                <div class="mapaCercleAsia d-none d-lg-block" data-aos="zoom-in" data-aos-delay="1000" data-aos-easing="easy-out" data-aos-duration="1000">
                    <div class="contentCercle">
                        <img :src="`${publicPath}img/mapaCercleAsiaOn_${locale}.png`" class="mapaCercleOn img-responsive">
                        <img :src="`${publicPath}img/mapaCercleAsia_${locale}.png`" class="mapaCercleOff img-responsive">
                    </div>
                </div>
                <div class="mapaCercleEuropa d-none d-lg-block" data-aos="zoom-in" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                    <div class="contentCercle">
                        <img :src="`${publicPath}img/mapaCercleEuropaOn_${locale}.png`" class="mapaCercleOn img-responsive">
                        <img :src="`${publicPath}img/mapaCercleEuropa_${locale}.png`" class="mapaCercleOff img-responsive">
                    </div>
                </div>
                <div class="mapaCercleOceania d-none d-lg-block" data-aos="zoom-in" data-aos-delay="1500" data-aos-easing="easy-out" data-aos-duration="1000">
                    <div class="contentCercle">
                        <img :src="`${publicPath}img/mapaCercleOceaniaOn_${locale}.png`" class="mapaCercleOn img-responsive">
                        <img :src="`${publicPath}img/mapaCercleOceania_${locale}.png`" class="mapaCercleOff img-responsive">
                    </div>
                </div>
                <div class="baseMapa">
                    <img :src="`${publicPath}img/mapa.png`" class="img-responsive">
                </div>


            </div>
        </div>
        <div class="row">
            <div class="mapaDatus">
                <div class="row p-0 m-0">
                    <div class="col-4">
                        <img :src="`${publicPath}img/mapaPlanta.png`" class="img-responsive">
                    </div>
                    <div class="col-8 text-start">
                        <h3>
                            <AnimatedNumber
                                    ref='counter_products_plants'
                                    :startAmount='0'
                                    :endAmount='76'
                                    :duration='3'
                                    :separator=separator
                                    :decimals='0'
                                    :autoinit='true'
                            />
                        </h3>
                        <p class="mb-2"> {{$t('mundo.plantas-prod')}}</p>
                    </div>
                    <hr class="mb-2">
                </div>
                <div class="row p-0 m-0">
                    <div class="col-4">
                        <img :src="`${publicPath}img/mapaPaises.png`" class="img-responsive">
                    </div>
                    <div class="col-8 text-start">
                        <h3>
                            +<AnimatedNumber
                                ref='counter_paises'
                                :startAmount='0'
                                :endAmount='170'
                                :duration='3'
                                :separator=separator
                                :decimals='0'
                                :autoinit='true'
                        />
                        </h3>
                        <p class="mb-2">{{$t('mundo.paises')}}</p>
                    </div>
                    <hr class="mb-2">
                </div>
            </div>

        </div>
    </div>

    <div class="container position-relative p-0 m-0 pb-5" v-else>
        <div class="row position-absolute titMapa">
            <div class="col-12 text-uppercase">
                <h4 v-html="$t('mundo.rc-mundo')"></h4>
            </div>
        </div>
        <div id="carouselExampleControls" class="carousel slide fullHeight fonsMapa pt-0" data-bs-interval="false" data-bs-ride="carousel" data-bs-wrap="true">
            <div class="carousel-inner">

                <div class="carousel-item position-relative">
                    <div class="position-absolute bottom-0 w-100">
                        <table width="100%" @click="mapaA=true">
                            <tr>
                                <td align="center">
                                    <h4 class="txtBlau3" v-html="$t('mundo.america')"></h4>
                                    <table>
                                        <tr>
                                            <td>
                                                <img :src="`${publicPath}img/mapaPlanta.png`" class="img-responsive mb-2" width="40">
                                            </td>
                                            <td valign="bottom">
                                                <h2 class="pb-0 mb-0">
                                                    <AnimatedNumber
                                                            ref='counter_products_plants'
                                                            :startAmount='0'
                                                            :endAmount='14'
                                                            :duration='3'
                                                            :separator=separator
                                                            :decimals='0'
                                                            :autoinit='true'
                                                    />
                                                </h2>
                                            </td>
                                        </tr>
                                    </table>
                                    <p class="text-white">{{$t('mundo.plantas')}}</p>
                                </td>
                                <td align="center">

                                </td>
                            </tr>
                        </table>

                    </div>

                    <img :src="`${publicPath}img/mobileMapaA.png`" class="img-responsive mb-4">
                </div>
                <div class="carousel-item active position-relative">
                    <div class="position-absolute bottom-0 w-100">
                        <table width="100%" @click="mapaA=true">
                            <tr>
                                <td align="center">
                                    <h4 class="txtGroc">{{$t('mundo.europa')}}</h4>
                                    <table>
                                        <tr>
                                            <td>
                                                <img :src="`${publicPath}img/mapaPlanta.png`" class="img-responsive mb-2" width="40">
                                            </td>
                                            <td valign="bottom">
                                                <h2 class="pb-0 mb-0">
                                                    <AnimatedNumber
                                                            ref='counter_products_plants'
                                                            :startAmount='0'
                                                            :endAmount='34'
                                                            :duration='3'
                                                            :separator=separator
                                                            :decimals='0'
                                                            :autoinit='true'
                                                    />
                                                </h2>
                                            </td>
                                        </tr>
                                    </table>
                                    <p class="text-white">{{$t('mundo.plantas')}}</p>
                                </td>
                                <td align="center">
                                    <h4 class="txtVerd">{{$t('mundo.africa')}}</h4>
                                    <table>
                                        <tr>
                                            <td>
                                                <img :src="`${publicPath}img/mapaPlanta.png`" class="img-responsive mb-2" width="40">
                                            </td>
                                            <td valign="bottom">
                                                <h2 class="pb-0 mb-0">
                                                    <AnimatedNumber
                                                            ref='counter_products_plants'
                                                            :startAmount='0'
                                                            :endAmount='7'
                                                            :duration='3'
                                                            :separator=separator
                                                            :decimals='0'
                                                            :autoinit='true'
                                                    />
                                                </h2>
                                            </td>
                                        </tr>
                                    </table>
                                    <p class="text-white">{{$t('mundo.plantas')}}</p>

                                </td>
                            </tr>
                        </table>


                    </div>

                    <img :src="`${publicPath}img/mobileMapaB.png`" class="img-responsive mb-4">
                </div>
                <div class="carousel-item">
                    <div class="position-absolute bottom-0 w-100">
                        <table width="100%" @click="mapaA=true">
                            <tr>
                                <td align="center">
                                    <h4 class="text-white">{{$t('mundo.asia')}}</h4>
                                    <table>
                                        <tr>
                                            <td>
                                                <img :src="`${publicPath}img/mapaPlanta.png`" class="img-responsive mb-2" width="40">
                                            </td>
                                            <td valign="bottom">
                                                <h2 class="pb-0 mb-0">
                                                    <AnimatedNumber
                                                            ref='counter_products_plants'
                                                            :startAmount='0'
                                                            :endAmount='20'
                                                            :duration='3'
                                                            :separator=separator
                                                            :decimals='0'
                                                            :autoinit='true'
                                                    />
                                                </h2>
                                            </td>
                                        </tr>
                                    </table>
                                    <p class="text-white">{{$t('mundo.plantas')}}</p>
                                </td>
                                <td align="center">
                                    <h4 class="text-white">{{$t('mundo.oceania')}}</h4>
                                    <table>
                                        <tr>
                                            <td>
                                                <img :src="`${publicPath}img/mapaPlanta.png`" class="img-responsive mb-2" width="40">
                                            </td>
                                            <td valign="bottom">
                                                <h2 class="pb-0 mb-0">1</h2>
                                            </td>
                                        </tr>
                                    </table>
                                    <p class="text-white">{{$t('mundo.planta')}}</p>

                                </td>
                            </tr>
                        </table>


                    </div>

                    <img :src="`${publicPath}img/mobileMapaC.png`" class="img-responsive mb-4">
                </div>
            </div>
            <button class="carousel-control-prev mt-0 pt-0" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                <img :src="`${publicPath}img/carouselBackB.png`" class="img-responsive">
                <span class="visually-hidden">{{ $t('previous') }}</span>
            </button>
            <button class="carousel-control-next mt-0 pt-0" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                <img :src="`${publicPath}img/carouselNextB.png`" class="img-responsive">
                <span class="visually-hidden">{{ $t('next') }}</span>
            </button>
        </div>
    </div>

    <!-- Footer -->
    <footer>
        <div class="row p-0 g-0">
            <div class="col-6 border-top border-dark">
                <localized-link to="/roca-group-2022/2022-en-resumen" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
                    <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaLeft">
                            <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
                        </svg>
                    </div>
                    <div class="col-6 col-lg-auto text-start p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.anterior')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block">{{$t('nav.resumen')}}</h2>
                    </div>
                </localized-link>
            </div>
            <div class="col-6 border-top border-start border-dark">
                <localized-link to="/avanzando-hacia-el-futuro" class="row justify-content-end p-0 m-0 my-0 my-lg-5">

                    <div class="col-6 col-lg-auto text-end p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.siguiente')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block">{{$t('site.avanzando-hacia-el-futuro')}}</h2>
                    </div>
                    <div class="col-4 col-lg-auto p-0 pe-5 me-0 me-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaRight">
                            <use :href="`${publicPath}icons.svg#fletxaRight`"/>
                        </svg>
                    </div>

                </localized-link>
            </div>
        </div>
    </footer>
    <!-- Footer -->

</template>


<script>
    import AnimatedNumber from 'vue3-autocounter'
    export default {
      components: {
          AnimatedNumber
      },
      props: {
          hasChildren: Boolean
      },
      data() {
          return {
              publicPath: process.env.BASE_URL,
              separator: '.',
              mapaA: false,
              locale:this.$i18n.locale
          }
      },
      mounted() {
        document.addEventListener('aos:in:counter', this.startCounter);
        if(this.$i18n.locale=="es"){
            this.separator = '.';
        } else {
            this.separator = ',';
        }
      },
        methods: {
            isMobile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            },
            startCounter() {
          if (this.$refs.counter_products_plants != null) {
            this.$refs.counter_products_plants.start();
          }
          if (this.$refs.counter_paises != null) {
            this.$refs.counter_paises.start();
          }
          if (this.$refs.counter_empleados != null) {
            this.$refs.counter_empleados.start();
          }
        }
      }
    }
</script>
